import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// ===== SECURITE : forcer un login fresh a chaque nouvelle session navigateur =====
// sessionStorage persiste tant que l'onglet reste ouvert mais est efface quand le navigateur est ferme
// Si pas de flag "session_active", on efface le token : l'utilisateur doit se reloguer
(function enforceFreshLoginPerSession() {
  try {
    const sessionActive = sessionStorage.getItem('session_active');
    if (!sessionActive) {
      // Nouvelle session navigateur (ou cache vide) : forcer login
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('workspaceContext');
    }
  } catch (e) {
    // sessionStorage indisponible (rare), ne rien faire
    console.warn('sessionStorage indisponible:', e);
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
